import { createFileRoute } from '@tanstack/react-router';
import { Prose } from '@leanin/ui/server';
import { LegalShell } from '@/components/legal/LegalShell';
import termsMarkdown from '../content/legal/terms.md?raw';

export const Route = createFileRoute('/terms')({
  component: TermsPage,
});

function TermsPage() {
  return (
    <LegalShell title="Terms of Service">
      <Prose source={termsMarkdown} />
    </LegalShell>
  );
}
